import { useRef, useEffect, useCallback } from 'react';

function useDebounceCallback(cb) {
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var lastTimeoutId = useRef();
  var mounted = useRef(true);
  useEffect(function () {
    mounted.current = true;
    return function () {
      mounted.current = false;
    };
  }, []); // eslint-disable-next-line react-hooks/exhaustive-deps

  var memoCb = useCallback(cb, args);
  var callback = useCallback(function () {
    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    if (lastTimeoutId.current) {
      clearTimeout(lastTimeoutId.current);
    }

    lastTimeoutId.current = setTimeout(function () {
      if (mounted.current) {
        memoCb.apply(void 0, params);
      }
    }, delay);
  }, [memoCb, delay]);
  return callback;
}

export default useDebounceCallback;
